import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

/*import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";*/
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import {DashboardAPI, LeadPerformanceReportAPI} from "./../../API/Admin/DashboardAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import PieChart from "../../utils/Charts/PieChart";
//import LeadSourcePieChart from 'react-apexcharts';
import Layout from "./Layout";



const Dashboard = () =>{

	const [sourcechartloading, setSourceChartLoading] = useState(false);
	const [leadstatuschartloading, setLeadStatusChartLoading] = useState(false);
	const [campaignperformchartloading, setCampaignPerformChartLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [campaignslist, setCampaignsList] = useState([]);
	const [sourceoptionslist, setSourceOptionsList] = useState([]);
	const [sourceserieslist, setSourceSeriesList] = useState([]);
	const [usercount, setUserCount] = useState(0);
	const [campaigncount, setCampaignCount] = useState(0);
	const [leadcount, setLeadCount] = useState(0);
	const [convertedleadcount, setConvertedLeadCount] = useState(0);
	const [showleadperformchart, setShowLeadPerformChart] = useState(true);
	const [leadperformseries, setLeadPerformSeries] = useState([]);
	const [leadperformoptions, setLeadPerformOptions] = useState([]);
	const [filtercampaignid, setFilterCampaignID] = useState(0);

	useEffect(() =>{

		DashboardAPI(setCampaignsList, setSourceOptionsList, setSourceSeriesList, setUserCount, setCampaignCount, setLeadCount, setConvertedLeadCount, setLoading);
		LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, "");
	}, []);

	const handleSelectCampaign = (e) =>{
		
		const filterparams = new URLSearchParams();

        if(e.target.value > 0)
        {
            filterparams.append('filtercampaignid', e.target.value);

			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, filterparams);
        }
		else
		{
			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, '');
		}
		
	}


    return(
    <Layout>
		<div className="content">
			<div className="row">
				<div className="col-md-12">
					<div className="page-header">
						<div className="row align-items-center ">
							<div className="col-md-4">
								<h3 className="page-title">Leads Dashboard</h3>
							</div>
							<div className="col-md-8 float-end ms-auto">
								<div className="d-flex title-head">
									{/*	<div className="daterange-picker d-flex align-items-center justify-content-center">
										<div className="form-sort me-2">
											<i className="ti ti-calendar"></i>
											<input type="text" className="form-control  date-range bookingrange" />
										</div>
										<div className="head-icons mb-0">
											<Link to="" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Refresh">
												<i className="ti ti-refresh-dot"></i>
											</Link>
											<Link to="" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Collapse" id="collapse-header">
												<i className="ti ti-chevrons-up"></i>
											</Link>
										</div>
									</div>*/}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xl-3 col-lg-6">
					<div className="campaign-box bg-purple-light">
						<div className="campaign-img">
							<span>
								<i className="ti ti-brand-feedly"></i>
							</span>
							<p>Total Users</p>
						</div>
						<h2>{ usercount }</h2>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6">
					<div className="campaign-box bg-danger-light">
						<div className="campaign-img">
							<span>
								<i className="ti ti-brand-campaignmonitor"></i>
							</span>
							<p>Active Campaigns</p>
						</div>
						<h2>{campaigncount}</h2>
					</div>
				</div>
				<div className="col-xl-3 col-lg-6">
					<div className="campaign-box bg-warning-light">
						<div className="campaign-img">
							<span>
								<i className="ti ti-send"></i>
							</span>
							<p>Total Leads</p>
						</div>
						<h2>{leadcount}</h2>
					</div>
				</div>
				
				<div className="col-xl-3 col-lg-6">
					<div className="campaign-box bg-success-light">
						<div className="campaign-img">
							<span>
								<i className="ti ti-brand-pocket"></i>
							</span>
							<p>Converted Leads</p>
						</div>
						<h2>{convertedleadcount}</h2>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-7">
					<div className="card">
						<div className="card-header border-0 pb-0">
							<div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
								<h4><i className="ti ti-grip-vertical me-1"></i>Campaigns</h4>
								<div className="dropdown">
									
									<div className="dropdown-menu dropdown-menu-end">
										
									</div>
								</div>
							</div>
						</div>
						<div className="card-body">
							<div className="table-responsive custom-table">
								<table className="table dataTable" id="lead-project">
									<thead className="thead-light">
										<tr>
											<th>Campaign Name</th>
											<th>Sales Manager</th>
											<th>Total Leads</th>
											<th>Enrolled Leads</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										{ campaignslist && campaignslist.length > 0 ?
											(campaignslist.map(campaign =>
										<tr key={campaign.id}>
											<td>
												<Link className="fw-medium">{ campaign.name }</Link>
											</td>
											<td>{campaign.sales_person}</td>
											<td>{campaign.leadcount}</td>
											<td>{campaign.converted}</td>
											<td>
												<Link to={`/admin/campaign-report/${campaign.id}`}>
												<span className="badge badge-pill bg-success">View Report</span>
												</Link>
											</td>
										</tr>
											))
										:
											<tr>
												<td colSpan="5">
													<p>No record found...</p>
												</td>
											</tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-5 d-flex">
					<div className="card w-100">
						<div className="card-header border-0 pb-0">
							<div className="row">
								<div className="col-md-6">
									<h4>Lead Performance</h4>
								</div>
								<div className="col-md-6">
									<div className="dropdown">
										<select className="form-select" name="caller" onChange={handleSelectCampaign}>
											<option value="">All</option>
											{campaignslist.map((campaign) =>
												(
													<option key={campaign.id} value={campaign.id}>{campaign.name}</option>
													
												))                                        
											}
										</select>
									</div>
								</div>
							</div>
						</div>
						<div className="card-body">
							<div id="leadpiechart chart-min-height">
								{showleadperformchart ?
									<Loader />
								:
									<PieChart seriesdata={leadperformseries} labeldata={leadperformoptions} />
								}
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</Layout>
    )
}

export default Dashboard;